import { SKIP_CONVERSION_PATHS } from "../../common/skipConversionPaths";
import { transformAll } from "../../migrations/multilingual-to-array/transformAll";
import { ensureLanguageField } from "../../types-converter/languageFieldConverter";
import { SanityDocument } from "@sanity/client";

export type FixMultilingualResult = {
  transformed: SanityDocument;
  converted: number;
  convertedPaths: string[];
  languageFixed: number;
  languageFixedPaths: string[];
  unsupportedLanguages: string[];
};

export function fixDocumentMultilingual(
  doc: SanityDocument
): FixMultilingualResult {
  const arrayPass = transformAll(doc, {
    skipConversionPaths: SKIP_CONVERSION_PATHS
  });
  const languagePass = ensureLanguageField(arrayPass.transformed);

  return {
    transformed: languagePass.transformed,
    converted: arrayPass.converted,
    convertedPaths: arrayPass.convertedPaths,
    languageFixed: languagePass.fixed,
    languageFixedPaths: languagePass.fixedPaths,
    unsupportedLanguages: languagePass.unsupportedLanguages
  };
}
